import { Component } from '@angular/core';

@Component({
  selector: 'app-feed-404-container',
  template: '<h3>Feed 404</h3>'
})
export class Feed404Container {}
